import { gql } from '@apollo/client';
import { CART_DATA_DEFAULT_RESULT_PROPS } from './constants';

const GET_CURRENCIES_QUERY = gql`
  query {
    currencies: getCurrencies {
      id
      name
      code
    }
  }
`;

const GET_PRODUCT_VARIANTS_QUERY = gql`
  query ecommerceGetProductVariants($id: String, $currency: String, $entityIdentifier: String) {
    productVariants: ecommerceGetProductVariants(
      id: $id
      currency: $currency
      entityIdentifier: $entityIdentifier
    ) {
      variantId
      name
      attributes
      price
      isPreorder
      isAvailable
      stockLabel
      minQuantity
      maxQuantity
    }
  }
`;

const GET_CART_QUERY = gql`
  query ecommerceGetCart($id: String!, $currency: String) {
    cartData: ecommerceGetCart(id: $id, currency: $currency) {
      ${CART_DATA_DEFAULT_RESULT_PROPS}
    }
  }
`;

const GET_PUBLISHED_PRODUCT_QUERY = gql`
  query getPublishedProduct($id: String!) {
    productData: getPublishedProduct(id: $id) {
      name
    }
  }
`;

const GET_USER_ADDRESSES = gql`
  query getUserAddresses {
    userAddresses: getUserAddresses {
      isDefaultBilling
      isDefaultShipping
      id
      title
      firstname
      lastname
      company
      country
      countryName
      county
      countyName
      address1
      address2
      city
      postcode
      tel
    }
  }
`;

const GET_PRODUCT = props => gql`
  query getProduct($id: String!) {
    product: getPublishedProduct(id: $id) {
      id
      name
      url
      image {
        url
      }
    ${props}
    }
  }
`;

const GET_COUNTRIES = gql`
  query getCountries {
    countries: getCountries(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
      code
    }
  }
`;

const GET_TITLES = gql`
  query getTitles {
    titles: getTitles {
      id
      name
    }
  }
`;

const GET_COUNTIES_BY_COUNTRY_ID = gql`
  query getCounties($countryId: String!) {
    counties: getCounties(
      where: { countryId: $countryId }
      sort: [{ property: "name", direction: "asc" }]
    ) {
      code
      name
      countryId
      country {
        code
        name
      }
    }
  }
`;

const GET_ORDER = gql`
  query ecommerceGetOrder($id: String!) {
    order: ecommerceGetOrder(id: $id) {
      id
      date
      cart {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

const GET_ORDERS = gql`
  query ecommerceGetOrders($limit: Int, $offset: Int) {
    orders: ecommerceGetOrders(limit: $limit, offset: $offset) {
      id
      date
      cart {
        ${CART_DATA_DEFAULT_RESULT_PROPS}
      }
    }
  }
`;

export {
  GET_ORDER,
  GET_ORDERS,
  GET_COUNTIES_BY_COUNTRY_ID,
  GET_COUNTRIES,
  GET_CURRENCIES_QUERY,
  GET_PRODUCT,
  GET_TITLES,
  GET_PRODUCT_VARIANTS_QUERY,
  GET_CART_QUERY,
  GET_PUBLISHED_PRODUCT_QUERY,
  GET_USER_ADDRESSES
};
